import type { NotificationResponse } from '@stw/types';

import { stwFetch } from '@/utils/stwFetch';

/**
 * Get the current user's notification history (paginated, read + unread)
 */
export const getNotifications = async (
  page = 1,
  pageSize = 20
): Promise<{
  notifications: NotificationResponse[];
  totalItems: number;
  pageSize: number;
  totalPages: number;
}> => {
  const params = new URLSearchParams();
  params.append('page', page.toString());
  params.append('pageSize', pageSize.toString());

  return stwFetch('GET', `/notifications?${params}`);
};

/**
 * Get the unread notification count, for the bell badge
 */
export const getUnreadNotificationCount = async (): Promise<{
  count: number;
}> => {
  return stwFetch('GET', '/notifications/unread-count');
};

/**
 * Mark one notification as read
 */
export const markNotificationRead = async (id: string): Promise<void> => {
  await stwFetch('PATCH', `/notifications/${id}/read`);
};

/**
 * Mark all notifications as read
 */
export const markAllNotificationsRead = async (): Promise<void> => {
  await stwFetch('PATCH', '/notifications/read-all');
};
